<template>
  <div>
    <div v-masonry gutter="15" transition-duration="0s" item-selector=".item">
      <div v-bind:key="index"
           v-masonry-tile class="item" v-for="(url, index) in filteredUrls">
        <card class="border-0 mb-3" no-body shadow style="width: 21.5rem">

          <a :href="url.original_link" target="_blank">

            <img class="url-image img-fluid" v-if="url.micro.data.image"
                 :src="url.micro.data.image.url">
            <img class="position-absolute publisher-logo img-fluid" v-if="url.micro.data.logo"
                 :src="url.micro.data.logo.url">
          </a>
          <div class="px-3 mt-3 pb-3">

            <badge v-if="url.micro.data.date" type="primary mb-3" rounded>{{url.micro.data.date |
              formatDate}}
            </badge>
            <badge v-if="url.micro.data.publisher" type="orange mb-3" rounded>{{url.micro.data.publisher |
              formatPublisher }}
            </badge>

            <h6 class="text-primary">{{url.micro.data.title}}</h6>
            <p v-if="url.micro.data.description" class="description mt-3">{{url.micro.data.description|
              removeContinueReading}}</p>

            <base-button tag="a" :href="url.micro.data.url" target="_blank" type="primary"
                         class="mt-4 shadow text-white">
              Go to article
            </base-button>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'
import moment from 'moment'

export default {
  name: 'top-urls-masonry',
  directives: {
    imagesLoaded
  },
  props: {
    urls: {
      type: Array,
      description: 'Tweets for the masonry grid'
    }
  },
  computed: {
    filteredUrls () {
      return this.urls.filter(url => this.isValidUrl(url))
    }
  },
  filters: {
    formatDate (date) {
      return moment(date).format('D-MMM-YY')
    },
    removeContinueReading (description) {
      return description.replace('Continue reading →', '')
    },
    formatPublisher (publisher) {
      return publisher.substring(0, 30)
    }
  },
  created () {
    setInterval(() => this.$redrawVueMasonry(), 500)
  },
  methods: {
    isValidUrl (url) {
      if (url.micro.data.title && url.micro.data.image) {
        if (!url.micro.data.image.url.startsWith('https://facebook.com')) {
          return url
        }
      }
    },
    loadMore () {
      if (this.maxIndex < this.urls.length) {
        this.maxIndex += 9
      }
    }
  },
  data () {
    return {
      maxIndex: 9
    }
  }
}
</script>
<style>
  .publisher-logo {
    max-width: 40px;
    top: 12px;
    left: 12px;
  }
</style>
